<template>
  <div class="partner_box">
    <div class="policies_and_service" v-if="index">
      <div class="policies_service_title">
        <div class="policies_title">
          <img class="title_img" src="../assets/images/index/titleMark.png" alt="">
          <p> 合作伙伴 <span>Partner</span></p>
        </div>
      </div>
    </div>
    <div class="partner_title_box" v-else>
      <div class="line"></div>
      <div class="partner_title">
        <p class="cn">合作伙伴</p>
        <p class="en">Partner</p>
      </div>
    </div>

    <div class="partner_box">
      <div class="partner">
        <a class="partner_list" :href="item.logoUrl" v-for="(item,index) in partnerList" :key="index" target="_blank">
          <img :src="item.partnerLogo" alt="">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { queryPartner } from '@/api/Partner.js'
  export default {
    data() {
      return {
        index: this.$route.name == 'Index',
        //合作伙伴列表
        partnerList: []
      }
    },
    created(){
      this.getPartnerList()
    },
    methods:{
      getPartnerList(){
        queryPartner().then((res)=>{
         this.partnerList = res
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .partner_box {
    //合作伙伴
    width: 100%;
    .policies_and_service {
      width: 100%;
      height: 64px;
      border-bottom: 1px solid #ccc;
      margin-top: 80px;
      margin-bottom: 50px;
      display: flex;
      justify-content: center;
      .policies_service_title {
        width: 1200px;
        display: flex;
        .policies_title {
          display: flex;
          align-items: center;
          img {
            width: 34px;
            height: 30px;
          }
          p {
            font-size: 28px;
            margin-left: 20px;
            color: #3c3c3c;
            span {
              font-size: 16px;
              margin-left: 10px;
              color: #999;
            }
          }
        }
        .policies_title {
          width: 490px;
          height: 64px;
          margin-right: 40px;
        }
      }
    }
    .partner_title_box {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: 20px;
      .line {
        width: 100%;
        height: 1px;
        background-color: #ccc;
      }
      .partner_title{
        width: 180px;
        height: 80px;
        position: absolute;
        top: 30px;
        left: 50%;
        margin-left: -90px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .cn{
          font-size: 28px;
          color: #333;
        }
        .en{
          font-size: 16px;
          color: #666;
        }
      }
    }
    .partner_box {
      width: 100%;
      display: flex;
      justify-content: center;
      .partner {
        width: 1200px;
        /*height: 300px;*/
        margin: 30px 0 100px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: flex-start;
        .partner_list {
          display: block;
          width: 210px;
          height: 94px;
          margin: 10px 30px 30px 0;
          img{
            width: 100%;
            //height: 100%;
          }
        }
      }
    }
  }
</style>
